module.exports = __webpack_public_path__ + "img/11.9dfbae03.jpg";